import React from "react";
import { Choice, Connect, Recive } from "../svg/other";

export function OurProcess() {
  return (
    <section className="que-process">
      <div className="que-process-container">
        <h1 className="que-process-heading">
          Find the Best Offers in<span> #3 Simple Steps</span>
        </h1>
        <div className="que-step-wrapper">
          <div className="que-step-container">
            <div className="que-step-content">
              <h3>Step-1</h3>
              <h2>Connect With Providers</h2>
              <p>
                Fill out our simple questionnaire and we’ll connect you with the
                ideal providers to suit your needs.
              </p>
            </div>
            <div className="que-step-icon">
              <Connect />
            </div>
          </div>
          <div className="que-step-container">
            <div className="que-step-content">
              <h3>Step-2</h3>
              <h2>Receive Quotes</h2>
              <p>Receive obligation-free custom quotes that you can compare.</p>
            </div>
            <div className="que-step-icon">
              <Recive />
            </div>
          </div>
          <div className="que-step-container">
            <div className="que-step-content">
              <h3>Step-3</h3>
              <h2>Make a Choice</h2>
              <p>
                Pick an offer that suits you or keep shopping. It’s your choice!
              </p>
            </div>
            <div className="que-step-icon">
              <Choice />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
